import ModalStore from '../../../../../../components/Modal/Store';

const expiredAccessModalStore = new ModalStore();

export { expiredAccessModalStore };
